export default __webpack_public_path__ + "static/title-gallery-ja-bc2a5c1cb4155a7befb6edf0531ee4e6.png";